/**
 * A general Range model
 * @property from The from value in the range.
 * @property to The to value in the range.
 */
export interface Range<T = number> {
    /** The from value in the range */
    from: T;

    /** The to value in the range */
    to: T;
}

export function isValidDateRange(range: Range<Date>) {
    return range.from instanceof Date && range.to instanceof Date;
}
